import _color from '@/assets/utils/color.js'

export function getHex(color) {
  if (_color.isColor(color)) {
    let rgb  = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${color}`);
    rgb = rgb.split(",");
    return "#" + ((1 << 24) + (Number(rgb[0]) << 16) + (Number(rgb[1]) << 8) + Number(rgb[2])).toString(16).slice(1);
  }
  return color
}
